import { SharedService } from './../../utils/shared.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Component, OnInit, Input,EventEmitter, Output } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddressModel } from './address.model';
import * as CommonConstants from '../../utils/common.constants';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { MasterService } from '../../masters/master.service';
import { ToastrService } from 'ngx-toastr';
import { eventNames } from 'process';

@Component({
  selector: 'app-add-address',
  templateUrl: './add-address.component.html',
  styleUrls: ['./add-address.component.scss']
})
export class AddAddressComponent implements OnInit {

  address: AddressModel = new AddressModel();
  addressList: AddressModel[] = [];
  townList: any = [];
  townListByCountry=[];
  countryList: any = [];
  addressTypeList: any = [];
  addressForm: FormGroup;
  @Input() partnerId: number;
  @Input() partnerType: number;
  submitted = false;
  columnDefs: any[];
  toggleDiv = true;
  @Output() patientAddress = new EventEmitter();
  patientAddressId;
  patientAddressType;
  constructor(private http: HttpClient, private masterService: MasterService, config: NgbModalConfig,
    private modalService: NgbModal, private formBuilder: FormBuilder,
    private sharedService: SharedService, private toastrService: ToastrService) {
    this.address.addressType = this.address.cotryId = this.address.townId = null;
    this.getFromGroup();
    this.loadTown();
    this.loadCountry();
      this.loadAddressTypes();

      this.columnDefs = [
        { headerName: 'Address', field: 'addreVaLine1' },
        { headerName: 'Address Type', field: 'addressType'},
        { headerName: 'Country', field: 'countryName' },
        { headerName: 'town', field: 'townName'}       
      ];
  }

  ngOnInit() {
    this.address["staRecCode"]=true;
  }

  /**
  * Declare form group
  *  
  */
  private getFromGroup() {
    this.addressForm = this.formBuilder.group({
      'typeId': ['', Validators.required],
      'addreVaLine1': ['', Validators.required],
      'addreVaLine2': new FormControl(),
      'cotryId': new FormControl(),
      'addreVaPostalCode': new FormControl(),
      'townId': new FormControl(),
      'addreVaLatitude': new FormControl(),
      'addreVaLongitude': new FormControl(),
      'phone': new FormControl(),
      'staRecCode':[true]
      
    })
  }

  get f() { return this.addressForm.controls; }

  addressAddModal(addAddress) {
    this.submitted = false;
    this.address = new AddressModel();
    this.address["staRecCode"]=true;
    this.modalService.open(addAddress, { size: 'lg', container: '.page-content' });
  }

  onAddressRowSelect(address, addAddress) {
    this.modalService.open(addAddress, { size: 'lg', container: '.page-content' });
    this.address = JSON.parse(JSON.stringify(address.data)); //clone
    this.address["staRecCode"]=this.address["staRecCode"] ==='A' ? true : false;
  }

  saveAddress() {
    this.submitted = true;
    if (this.addressForm.invalid) {
      return;
    }
    this.address.partnerId = this.partnerId;
    this.address.partnerType = this.partnerType;
    this.address["staRecCode"]=this.address["staRecCode"] ? 'A' :'I';
    this.address["createdTime"]=this.address["createdTime"] ? this.sharedService.getDateFormat(this.address["createdTime"]) :null;
    this.address["modifiedTime"]=this.address["modifiedTime"] ? this.sharedService.getDateFormat(this.address["modifiedTime"]):null;
    this.http.post(CommonConstants.SAVE_ADDRESS, this.address)
      .subscribe(response => {
        if (response['code'] == 0) {
          this.toggleDiv = true;
          this.modalService.dismissAll("#addAddress");
          this.toastrService.success(response['message'], 'Success');
          this.address.addreId = response['result'];
          //This is for patient address save to get back the address id
          this.patientAddressId=this.address.addreId;
          //this.patientAddressType=this.address.addressType;
          this.patientAddress.emit(this.patientAddressId);
          this.addressList = this.sharedService.updateDuplicateRecord(this.address.addreId, this.addressList, "addreId", this.address);
          this.addressList =this.addressList.map(item => ({ ...item, 
            addressType: item.typeId ? this.addressTypeList.find(obj => obj.typeId === item.typeId).description : null, 
            townName: item.townId ? this.townList.find(town => town.townId === item.townId).townDescEn : null, 
            countryName: item.cotryId ? this.countryList.find(country => country.cotryId ===item.cotryId).cotryDescEn: null})); 
         
        } else {
          this.toastrService.error(response['message'], 'Error');
        }

      });
  }


  loadTown() {
    this.masterService.getTown().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.townList = response['result'];
      }
    });
  }

  loadCountry() {
    this.masterService.getCountry().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.countryList = response['result'];
      }
    });
  }
  onChangeCountry(event){
    if(event && event.cotryId){
      this.townListByCountry=this.townList.filter(town => town.cotryId===event.cotryId);
    }else{
      this.townListByCountry=this.townList;
    }
     

  }
  loadAddressTypes() {
    this.masterService.getAddressTypes().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.addressTypeList = response['result'];
      }
    });
  }

  toggleContent(){
    this.toggleDiv = !this.toggleDiv;
  }

}
